import React, { useEffect, useState, createContext, useContext } from 'react';
import { BrowserRouter, Route, Routes, Navigate, Link } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Login from './pages/Login.jsx';
import NotFound from './pages/NotFound.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Logout from './pages/Logout.jsx';
import Services from './pages/Dashboard/Services.jsx';
import Member from './pages/Dashboard/Member.jsx';
import Category from './pages/Dashboard/Categories.jsx';
import Products from './pages/Dashboard/Products.jsx';
import Sectors from './pages/Dashboard/Sectors.jsx';
import Certs from './pages/Dashboard/Certs.jsx';
import News from './pages/Dashboard/News.jsx';
import Clients from './pages/Dashboard/Clients.jsx';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    const expiry = sessionStorage.getItem("expiry");
    if (token && expiry && Date.now() > Number(expiry)) {
      setIsLoggedIn(true);
      const storedEmail = sessionStorage.getItem('email');
      if (storedEmail) {
        setEmail(storedEmail);
      }
    } else {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('email');
      sessionStorage.removeItem('expiry');
      setIsLoggedIn(false);
      setEmail('');
    }
    setIsLoading(false);
  }, []);

  const login = (email, token) => {
    setIsLoggedIn(true);
    setEmail(email);
    sessionStorage.setItem('email', email);
    sessionStorage.setItem('token', token);
  };

  const logout = () => {
    setIsLoggedIn(false);
    setEmail('');
    sessionStorage.removeItem('email');
    sessionStorage.removeItem('token');
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, email, login, logout, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => useContext(AuthContext);

const ProtectedRoute = ({ element }) => {
  const { isLoggedIn, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>; // Prevent redirect flicker
  }

  return isLoggedIn ? element : <Navigate to="/login" />;
};


const LoginRoute = ({ element }) => {
  const { isLoggedIn, isLoading } = useAuth();
  // if (isLoading) return <p>Loading...</p>;
  // return isLoggedIn ? <Navigate to="/dashboard" /> : element;
  if (isLoading) {
    return <div>Loading...</div>; // or a spinner
  }
  return isLoggedIn ? <Navigate to="/dashboard" /> : element;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route index={true} element={<LoginRoute element={<Login />} />} />
          <Route path="*" element={<NotFound />} />

          {/* Private Routes */}
          <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
          <Route path="/dashboard/services" element={<ProtectedRoute element={<Services />} />} />
          <Route path="/dashboard/members" element={<ProtectedRoute element={<Member />} />} />
          <Route path="/dashboard/categories" element={<ProtectedRoute element={<Category />} />} />
          <Route path="/dashboard/products" element={<ProtectedRoute element={<Products />} />} />
          <Route path="/dashboard/sectors" element={<ProtectedRoute element={<Sectors />} />} />
          <Route path="/dashboard/certs" element={<ProtectedRoute element={<Certs />} />} />
          <Route path="/dashboard/news" element={<ProtectedRoute element={<News />} />} />
          <Route path="/dashboard/clients" element={<ProtectedRoute element={<Clients />} />} />
          <Route path="/logout" element={<ProtectedRoute element={<Logout />} />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export { useAuth };
export default App;



